import request from '@/utils/request';

// 获取视导报告列表
export function getReportList(schoolId, params) {
  return request({
    url: `/v1/qws/get/evaluate/report-page/${schoolId}`,
    method: 'get',
    params: params
  });
}

// 课堂维度评价
export function getDimensionAssess(planId) {
  return request({
    url: `/v1/qws/get/class/dimension/assess/technology/${planId}`,
    method: 'get'
  });
}

// 课堂综合评价
export function getSynthesizeAssess(planId) {
  return request({
    url: `/v1/qws/get/class/synthesize/assess/${planId}`,
    method: 'get'
  });
}

// 课堂综合评语-六个维度
export function getLookupCategoryAssess(planId) {
  return request({
    url: `/v1/qws/get/plan/lookup-category/answers/${planId}`,
    method: 'get'
  });
}

// 课堂综合评语
export function getPositiveQuestionAssess(planId) {
  return request({
    url: `/v1/qws/get/plan/positive-question/${planId}`,
    method: 'get'
  });
}

// 视导报告通知标题信息
export function getNoticeTileInfo(planId) {
  return request({
    url: `/v1/qws/get/plan/${planId}/supervision-report`,
    method: 'get'
  });
}

